import LoginSignup from '@shared/modal-login-signup';
import { T_ } from '@shared/translation';
import { qtsp } from '@shared/tracking-qtsbinds';

const fixedBannerEl = document.getElementById('fixed-banner');
const fixedBannerCloseEl = document.getElementById('fixed-banner-close');
const repostBtnEl = document.querySelector('[data-repost-btn]');
const postBtnEl = document.querySelector('[data-post-btn]');
const fixedBannerInputEl = document.getElementById('fixed-banner-form-input');
const freelancerProfileLnkEls = Array.from(
  document.querySelectorAll('[data-freelancer-profile-lnk]'),
);
const signupButtonEls = Array.from(
  document.getElementsByClassName('pvp-logged-out-signup-button'),
);
const signupEmailEls = Array.from(
  document.getElementsByClassName('pvp-logged-out-signup-email'),
);
const moreLessEls = Array.from(
  document.getElementsByClassName('FreelancerInfo-about-moreLink'),
);
const bidInputEls = Array.from(document.querySelectorAll('[data-signup-bid]'));
const projectStateEls = document.querySelector('[data-project-state]');

bindEvents();

function bindEvents() {
  if (fixedBannerCloseEl && fixedBannerEl) {
    fixedBannerCloseEl.addEventListener('click', () => {
      fixedBannerEl.classList.add('is-hidden');
    });
  }

  if (repostBtnEl) {
    repostBtnEl.addEventListener('click', () => {
      addQTS('repost', repostBtnEl.dataset.repostBtn);
    });
  }

  if (postBtnEl) {
    postBtnEl.addEventListener('click', () => {
      addQTS('post', fixedBannerInputEl.value);
    });
  }

  if (freelancerProfileLnkEls) {
    freelancerProfileLnkEls.forEach(el => {
      el.addEventListener('click', () => {
        addQTS('profile-lnk', el.dataset.freelancerProfileLnk);
      });
    });
  }

  if (signupButtonEls) {
    signupButtonEls.forEach(buttonEl => {
      buttonEl.addEventListener('click', e => {
        e.preventDefault();
        const signupOptions = { isEmployer: false };
        let emailAddress = null;
        let bidAmount = null;
        signupEmailEls.some(emailEl => {
          if (emailEl.value) {
            emailAddress = emailEl.value;
            signupOptions.emailAddress = emailEl.value;
            bidInputEls.some(bidInputEl => {
              if (bidInputEl.value) {
                bidAmount = bidInputEl.value;
                return true;
              }
              return false;
            });
            return true;
          }
          return false;
        });
        addQTS(
          buttonEl.dataset.subsection,
          `email:${emailAddress},bid:${bidAmount}`,
        );
        initializeLoginSignup(signupOptions);
        return true;
      });
    });
  }

  if (moreLessEls) {
    moreLessEls.forEach(moreLessEl => {
      moreLessEl.addEventListener('click', e => {
        e.preventDefault();
        const descrEl = moreLessEl.parentNode.querySelector('.bid-descr');
        if (moreLessEl.classList.contains('more')) {
          descrEl.textContent = moreLessEl.parentNode.dataset.descrFull;
          descrEl.parentNode.classList.add('is-FreelancerInfo-about-detailed');
          moreLessEl.classList.remove('more');
          moreLessEl.classList.add('less');
          moreLessEl.textContent = T_('Less');
        } else {
          descrEl.textContent = moreLessEl.parentNode.dataset.descrShort;
          descrEl.parentNode.classList.remove(
            'is-FreelancerInfo-about-detailed',
          );
          moreLessEl.classList.remove('less');
          moreLessEl.classList.add('more');
          moreLessEl.textContent = T_('More');
        }
      });
    });
  }
}

function initializeLoginSignup(signupOptions) {
  const loginSignupCallback = () => {
    window.location.reload();
  };

  const loginSignup = new LoginSignup({
    el: document.getElementById('default-modal-placeholder'),
    loginClbk: loginSignupCallback,
    employerSignupClbk: loginSignupCallback,
    workerSignupClbk: loginSignupCallback,
  });

  loginSignup.showSignup(signupOptions);
  loginSignup.setBackdrop();
}

function addQTS(subsection, label) {
  qtsp.push({
    eventName: 'user_action',
    section: 's3-logged-out-pvp',
    subsection,
    label,
    action: 'click',
    name: projectStateEls.dataset.projectState,
  });
}
